import { IAppConfiguration } from '../cemexng2components/components/app-configuration';

export default [
  {
    feature: 'business-schedule-access',
    excludes: {
      country: [
        'MX',
        'US',
        'CO',
        'GB',
        'DE',
        'IL',
        'ES',
        'PA',
        'PE',
        'PR',
        'CR',
        'FR',
        'NI',
        'PL',
        'SV',
        'LV',
        'DO',
        'GT',
        'CZ',
        'PH'
      ]
    }
  },
  {
    feature: 'survey.hide-consolitadion-criteria',
    excludes: {
      country: ['AE']
    }
  },
] as IAppConfiguration[];
